export default __webpack_public_path__ + "static/media/5.1155aab1.jpg";